const NextCircle = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='30'
    height='30'
    viewBox='0 0 30 30'
    fill='#0e77ef'
    {...props}
  >
    <path
      id='e977'
      d='M15,0A14.7,14.7,0,0,0,9.155,1.172,14.931,14.931,0,0,0,1.172,9.155,14.7,14.7,0,0,0,0,15a14.7,14.7,0,0,0,1.172,5.845,14.931,14.931,0,0,0,7.983,7.983A14.7,14.7,0,0,0,15,30a14.7,14.7,0,0,0,5.845-1.172,14.931,14.931,0,0,0,7.983-7.983A14.7,14.7,0,0,0,30,15a14.7,14.7,0,0,0-1.172-5.845,14.931,14.931,0,0,0-7.983-7.983A14.7,14.7,0,0,0,15,0Zm6.123,15.82-5.3,5.3A.933.933,0,1,1,14.5,19.8l3.867-3.867H8.438a.938.938,0,0,1,0-1.875h9.932L14.5,10.2a.888.888,0,0,1,0-1.318.888.888,0,0,1,1.318,0l5.3,5.3a.873.873,0,0,1,.234.4.784.784,0,0,1,0,.425.784.784,0,0,1,0,.425A.873.873,0,0,1,21.123,15.82Z'
    />
  </svg>
)

export default NextCircle
